"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));

var _ReadyState = _interopRequireDefault(require("./ReadyState"));

var defaultState = {
  readyState: _ReadyState.default.PENDING
};

var isSameFetchId = function isSameFetchId(state, action) {
  return state.fetchId === action.fetchId;
};

var requestReducer = function requestReducer(state, action) {
  return (0, _objectSpread2.default)({}, state, {
    fetchId: action.fetchId,
    location: action.location,
    readyState: _ReadyState.default.LOADING
  });
};

var failureReducer = function failureReducer(state, action) {
  if (!isSameFetchId(state, action)) return state;
  return (0, _objectSpread2.default)({}, state, {
    error: action.error,
    fetchId: action.fetchId,
    location: action.location,
    readyState: _ReadyState.default.FAILURE
  });
};

var successReducer = function successReducer(state, action) {
  if (!isSameFetchId(state, action)) return state;
  return (0, _objectSpread2.default)({}, state, {
    fetchId: action.fetchId,
    location: action.location,
    readyState: _ReadyState.default.SUCCESS
  });
};

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_FAILURE:
      return failureReducer(state, action);

    case _ActionTypes.default.FETCH_REQUEST:
      return requestReducer(state, action);

    case _ActionTypes.default.FETCH_SUCCESS:
      return successReducer(state, action);

    default:
      return state;
  }
}